module.exports = __webpack_public_path__ + "static/media/12.4cfb3990.jpg";